export default __webpack_public_path__ + "static/media/three.d4f751d1.svg";